import styled from "@emotion/styled";
import { Button, Modal, modalClasses, ModalContent, modalContentClasses } from "@kaltura/ds-react-components";
import { alpha } from "@kaltura/mediaspace-shared-styled";

export const StyledButton = styled(
    Button,
    {
        shouldForwardProp: (prop) => prop !== "isHeroAction",
    }
)<{ isHeroAction?: boolean }>(({ theme, isHeroAction }) => ({
    minWidth: "fit-content",
    color: theme.kaltura.palette.tone1,
    ...(
        isHeroAction && {
            color: theme.palette.common.white,
            "&:hover": {
                color: theme.palette.common.white,
                backgroundColor: alpha(theme.palette.common.black, 0.7),
            },
        }
    ),
}));

export const StyledModal = styled(
    Modal,
    {
        shouldForwardProp: (prop) => prop !== "showEmbed" && prop !== "showNoPlayers",
    }
)<{ showEmbed?: boolean; showNoPlayers?: boolean }>(({ theme, showEmbed = false, showNoPlayers = false }) => ({
    [`& .${modalClasses.paper}`]: {
        minWidth: showNoPlayers ? 558 : showEmbed ? 1200 : 646,
        [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
            minWidth: showNoPlayers ? 558 : showEmbed ? 960 : 646,
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            minWidth: showEmbed ? 391 : 552,
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            minWidth: "100%",
        },
    },
}));

export const StyledModalContent = styled(ModalContent)(({ theme }) => ({
    [`&.${modalContentClasses.root}`]: {
        paddingBottom: theme.spacing(5),
    },
}));
